import {ProductInListElementType, ProductInListMapType, ProductInSearchParamType} from "../interface";

export const productInSearchParamInit: ProductInSearchParamType = {
    keyword: "",
    keywordType: "1",
    limit: 10,
    pageNo: 1,
    statusCodeList: ["N"] // ["Y", "N"]
}

export const productInListMapInit: ProductInListMapType = {
    totalCount: 0,
    productList: []
}

export const productInListElementInit: ProductInListElementType = {
    newErpProductid: "",
    vendor: "",
    category: "",
    new_txt_nm_item: "",
    new_txt_stnd_item: "",
    majorCategory: "",
    subCategory: "",
    currency: "",
    levelA: "",
    levelB: "",
    levelC: "",
    levelD: "",
    levelE: "",
    productRange: ""
}